import React from 'react';
import './Page.css';
import {DocumentTitle} from '../widgets';

/**
 * Generic page wrapper. Allow for consistent style and decoration.
 */
const Page = ({children, className, title}) => {
	return (
		<DocumentTitle title={title}>
			<div className={`Page ${className || ''}`}>{children}</div>
		</DocumentTitle>
	);
};

export default Page;



// WEBPACK FOOTER //
// ./src/pages/Page.js